import { Typography } from "@mui/material";
import React from "react";

export const DashValueDrawer: React.FC<{ value: React.ReactNode, color?: string; bold?: boolean; }> = ({ value, color, bold = true }) => {
    return value == null ? null : <Typography variant={bold ? "body1" : "caption"} color={color ?? "primary"}>{bold ? <b>{value}</b> : value} </Typography>;
};